import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
// import Link from 'next/link';
import { Link, useNavigate } from "react-router-dom";
import { Button } from "ui/button";
import { StateCustomer, createCustomer } from "lib/actions";
import { useState, useRef } from "react";
import { PhoneInput } from "ui/components/common";
import { validatePhoneNumber } from "lib/utils";

export default function Form() {
  interface formDataType {
    [key: string]: FormDataEntryValue;
  }
  const responseBody: formDataType = {};
  const navigate = useNavigate();

  const [responseData, setResponseData] = useState<StateCustomer>();
  const [btnSubmitDisabled, setBtnSubmitDisabled] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState("");

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (
      phoneNumber !== "" &&
      phoneNumber !== "+" &&
      !validatePhoneNumber(phoneNumber)
    ) {
      setResponseData({ errors: { phone: ["Invalid phone number"] } });
      return;
    }
    setResponseData(null);
    const formData = new FormData(event.currentTarget as HTMLFormElement);
    formData.forEach(
      (value, property: string) => (responseBody[property] = value),
    );
    formData.set("phone", phoneNumber);
    try {
      setBtnSubmitDisabled(true);
      const response = await createCustomer(formData);
      setBtnSubmitDisabled(false);
      setResponseData(response);
      if (response.strReturn) {
        navigate(`/dashboard/customers`);
      }
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="rounded-md p-4 md:p-6">
        <h2 className="text-lg font-medium mb-5">
          First, create an customer account
        </h2>

        {/* Customer Name */}
        <div className="mb-4">
          <label htmlFor="name" className="mb-2 block text-sm">
            Account Name (The name displayed on your customer list)
          </label>
          <div className="relative mt-2 rounded-md">
            <div className="relative">
              <input
                id="name"
                name="name"
                type="text"
                placeholder="Account Name"
                className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500"
                aria-describedby="name-error"
              />
            </div>
            <div id="name-error" aria-live="polite" aria-atomic="true">
              {responseData?.errors?.name &&
                responseData.errors.name.map((error: string) => (
                  <p className="mt-2 text-sm text-red-500" key={error}>
                    {error}
                  </p>
                ))}
            </div>
          </div>
        </div>

        {/* Customer Email */}
        <div className="mb-4">
          <label htmlFor="email" className="mb-2 block text-sm">
            Customer Email
          </label>
          <div className="relative mt-2 rounded-md">
            <div className="relative">
              <input
                id="email"
                name="email"
                type="text"
                placeholder="Customer Email"
                className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500"
                aria-describedby="email-error"
              />
            </div>
            <div id="email-error" aria-live="polite" aria-atomic="true">
              {responseData?.errors?.email &&
                responseData.errors.email.map((error: string) => (
                  <p className="mt-2 text-sm text-red-500" key={error}>
                    {error}
                  </p>
                ))}
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 md:gap-6">
          {/* First Name */}
          <div className="mb-4">
            <label htmlFor="first_name" className="mb-2 block text-sm">
              First Name
            </label>
            <div className="relative mt-2 rounded-md">
              <div className="relative">
                <input
                  id="first_name"
                  name="first_name"
                  type="text"
                  placeholder="First Name"
                  className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500"
                  aria-describedby="first-name-error"
                />
              </div>
              <div id="first-name-error" aria-live="polite" aria-atomic="true">
                {responseData?.errors?.first_name &&
                  responseData.errors.first_name.map((error: string) => (
                    <p className="mt-2 text-sm text-red-500" key={error}>
                      {error}
                    </p>
                  ))}
              </div>
            </div>
          </div>

          {/* Last Name */}
          <div className="mb-4">
            <label htmlFor="last_name" className="mb-2 block text-sm">
              Last Name
            </label>
            <div className="relative mt-2 rounded-md">
              <div className="relative">
                <input
                  id="last_name"
                  name="last_name"
                  type="text"
                  placeholder="Last Name"
                  className="block w-full rounded-md border border-gray-200 px-3 py-2 text-sm outline-2 placeholder:text-gray-500"
                  aria-describedby="last-name-error"
                />
              </div>
              <div id="last-name-error" aria-live="polite" aria-atomic="true">
                {responseData?.errors?.last_name &&
                  responseData.errors.last_name.map((error: string) => (
                    <p className="mt-2 text-sm text-red-500" key={error}>
                      {error}
                    </p>
                  ))}
              </div>
            </div>
          </div>
        </div>

        {/* Phone */}
        <div className="mb-4">
          <label htmlFor="phone" className="mb-2 block text-sm">
            Phone Number
          </label>
          <div className="relative mt-2 rounded-md">
            <div className="relative h-[37px]">
              <PhoneInput
                onChange={(phone) => {
                  setPhoneNumber(phone);
                }}
              />
            </div>
            <div id="phone-error" aria-live="polite" aria-atomic="true">
              {responseData?.errors?.phone &&
                responseData.errors.phone.map((error: string) => (
                  <p className="mt-2 text-sm text-red-500" key={error}>
                    {responseData.errors.phone}
                  </p>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6 flex justify-end gap-4">
        <Link
          to="/dashboard/customers"
          className="p-4 flex items-center rounded-lg bg-gray-100 px-4 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-200"
        >
          Cancel
        </Link>
        <Button type="submit" aria-disabled={btnSubmitDisabled}>
          Create Customer
        </Button>
      </div>
      {responseData?.message && (
        <div
          className="p-4 mb-4 mt-12 text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 flex items-center space-x-1"
          role="alert"
          aria-live="polite"
          aria-atomic="true"
        >
          <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
          <p className="text-sm text-red-500">{responseData.message}</p>
        </div>
      )}
    </form>
  );
}
